import { useEffect, useState } from "react";
import { Modal, Select, Form, Button, message } from "antd";
import { team_getUserNotInTask } from "../../../services/team";
import { update_task_member } from "../../../services/task_member";

interface AddMemberModalProps {
  isOpen: boolean;
  taskId: string;
  onSuccess: () => void;
  onCancel: () => void;
}

export const AddMemberModal = ({
  isOpen,
  taskId,
  onSuccess,
  onCancel,
}: AddMemberModalProps) => {
  const [form] = Form.useForm();
  const [members, setMembers] = useState<any[]>([]);
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchMembers();
    }
  }, [isOpen]);

  const fetchMembers = async () => {
    setLoadingMembers(true);
    try {
      const res = await team_getUserNotInTask(taskId);
      if (res.status === "success" && Array.isArray(res.data)) {
        setMembers(res.data);
      } else {
        setMembers([]);
      }
    } catch (error) {
      console.error("Error fetching members:", error);
      setMembers([]);
    } finally {
      setLoadingMembers(false);
    }
  };

  const handleSubmit = async () => {
    let values: any;
    try {
      values = await form.validateFields();
    } catch {
      // form validation error — do nothing
      return;
    }
    setSubmitting(true);
    try {
      const res = await update_task_member({
        user_id: values.user_id,
        task_id: taskId,
        role: values.role,
      });
      if (res.status === "success") {
        message.success("เพิ่มสมาชิกสำเร็จ");
        form.resetFields();
        onSuccess();
      } else {
        message.error(res.message || "เกิดข้อผิดพลาด");
      }
    } catch (err) {
      message.error("ไม่สามารถเพิ่มสมาชิกได้ กรุณาลองใหม่อีกครั้ง");
      console.error("AddMember error:", err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Add Member"
      open={isOpen}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={submitting}
          onClick={handleSubmit}
          style={{ backgroundColor: "#00215E" }}
        >
          Save
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item
          name="user_id"
          label="Member"
          rules={[{ required: true, message: "กรุณาเลือกสมาชิก" }]}
        >
          <Select
            showSearch
            loading={loadingMembers}
            placeholder="Select member"
            optionFilterProp="label"
            options={members.map((m) => ({
              value: m.user_id,
              label: `${m.name} (${m.email})`,
            }))}
          />
        </Form.Item>
        <Form.Item
          name="role"
          label="Role"
          rules={[{ required: true, message: "กรุณาเลือก role" }]}
        >
          <Select
            placeholder="Select role"
            options={[
              { value: 2, label: "Admin" },
              { value: 1, label: "Member" },
            ]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
